import { environment as prodEnvironment } from "./environment.prod";

export const environment = {
  ...prodEnvironment,

  api: {
    rootUrl: 'https://stage-api.resolve.com',
  },
  azureADB2C: {
    apiPermissionRootUrl: 'https://resolvepracticestage.onmicrosoft.com/client-gateway',
    authorityDomain: 'resolvepracticestage.b2clogin.com',
    clientId: '1ec97b1f-9936-431c-86aa-57863169a40c',
    userFlow: {
      name: 'B2C_1_SignInOnly',
      authority: 'https://resolvepracticestage.b2clogin.com/resolvepracticestage.onmicrosoft.com/B2C_1_SignInOnly',
    },
  },
  environmentType: 'staging',
  gtmAccountId: 'GTM-KLZP54C7',
  web: {
    rootUrl: 'https://stage.resolve.com'
  },
};
